import React, { useState } from "react";
import { BiCheckCircle } from "react-icons/bi";
import { FaClock } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import { IoClose } from "react-icons/io5";

const SpecialistPatientScreen = () => {
  const [sessionNotes, setSessionNotes] = useState([]);
  const [expandedNote, setExpandedNote] = useState(null);

  // Mock data - بيانات المريض
  const patient = {
    name: "الحاجة سماح محمد",
    age: 45,
    gender: "Female",
    id: "P-12345",
    phone: "+20 123 456 7890",
    assignedSessions: 8,
    completedSessions: 3,
  };

  // ملاحظات الدكتور الاستشاري
  const consultantNotes = {
    generalNotes: `المريضة تعاني من س و ص . تحتاج إلى س و ص و ع . 

يُنصح بالبدء بجلسات أسبوعية لمدة شهرين مع متابعة دورية.      .`,

    structuredSections: [
      {
        id: 1,
        title: "التشخيص",
        content: "دور برد شديد",
      },
    
    ],

    attachments: [
      {
        id: 1,
        name: "img.jpg",
        url: "https://via.placeholder.com/300x200/2dd4bf/ffffff?text=Medical+Report",
      },
      {
        id: 2,
        name: "image",
        url: "https://via.placeholder.com/300x200/14b8a6/ffffff?text=Lab+Results",
      },
    ],

    date: "2024-01-10",
    consultantName: "dr. Ahmed Mahmoud",
  };

  React.useEffect(() => {
    const notes = [];
    for (let i = 1; i <= patient.assignedSessions; i++) {
      notes.push({
        id: i,
        sessionNumber: i,
        content: "",
        status: "pending",
      });
    }
    setSessionNotes(notes);
  }, []);

  const updateSessionNote = (id, content) => {
    setSessionNotes(
      sessionNotes.map((note) =>
        note.id === id
          ? {
              ...note,
              content,
              status: content.trim() ? "completed" : "pending",
            }
          : note
      )
    );
  };

  const saveSessionNote = (id) => {
    const note = sessionNotes.find((n) => n.id === id);
    if (note && note.content.trim()) {
      alert(`Session ${note.sessionNumber} notes saved successfully!`);
    } else {
      alert("Please add some notes before saving.");
    }
  };

  return (
    <div className="min-h-screen ">
      <div className=" mx-auto">
       <div
          className="bg-white rounded-lg p-6 mb-6"
          style={{ boxShadow: "0 6px 14px rgba(41, 141, 159, 0.3)" }}
        >
          <div className="flex items-start justify-between mb-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-800 mb-2">
                {patient.name}
              </h1>
              <p className="text-gray-600">Patient ID: {patient.id}</p>
            </div>
            <div className="bg-primary text-white px-4 py-2 rounded-lg font-semibold">
              From Consltant: Ahmed{" "}
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-4">
            <div className="bg-teal-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Age</p>
              <p className="text-lg font-semibold text-primary_hover">
                {patient.age} years
              </p>
            </div>
            <div className="bg-teal-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Gender</p>
              <p className="text-lg font-semibold text-primary_hover">
                {patient.gender}
              </p>
            </div>
            <div className="bg-teal-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Phone</p>
              <p className="text-lg font-semibold text-primary_hover">
                {patient.phone}
              </p>
            </div>
            <div className="bg-teal-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Total Sessions</p>
              <p className="text-lg font-semibold text-primary_hover">
                {patient.assignedSessions}
              </p>
            </div>
            <div className="bg-emerald-50 p-3 rounded-lg">
              <p className="text-sm text-gray-600">Completed</p>
              <p className="text-lg font-semibold text-emerald-700">
                {sessionNotes.filter((n) => n.status === "completed").length}
              </p>
            </div>
          </div>
        </div>

        <div
          className="bg-white rounded-lg p-6 mb-6"
          style={{ boxShadow: "0 6px 14px rgba(41, 141, 159, 0.3)" }}
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-primary text-white p-2 rounded-lg">
              <FiFileText size={24} />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-800">
                Consultant Notes
              </h2>
              <p className="text-sm text-gray-600">
                By {consultantNotes.consultantName} • {consultantNotes.date}
              </p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-full"></span>
              General Observations
            </h3>
            <div className="bg-teal-50/50 p-4 rounded-lg border-l-4 border-primary">
              <p className="text-gray-700 whitespace-pre-line leading-relaxed">
                {consultantNotes.generalNotes}
              </p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-full"></span>
              Treatment Details
            </h3>
            <div className="space-y-4">
              {consultantNotes.structuredSections.map((section) => (
                <div
                  key={section.id}
                  className="bg-gradient-to-r from-teal-50 to-cyan-50 p-4 rounded-lg border border-teal-200"
                >
                  <h4 className="font-semibold text-teal-800 mb-2">
                    {section.title}
                  </h4>
                  <p className="text-gray-700 whitespace-pre-line">
                    {section.content}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* {consultantNotes.attachments.length > 0 && (
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-primary rounded-full"></span>
                Attachments
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {consultantNotes.attachments.map((file) => (
                  <div key={file.id} className="group cursor-pointer">
                    <img
                      src={file.url}
                      alt={file.name}
                      className="w-full h-32 object-cover rounded-lg border-2 border-teal-200 group-hover:border-primary/90 transition-colors"
                    />
                    <p className="text-xs text-gray-600 mt-2 truncate">
                      {file.name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )} */}
        </div>

        {/* <div
          className="bg-white rounded-lg p-6"
          style={{ boxShadow: "0 6px 14px rgba(41, 141, 159, 0.3)" }}
        >
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="bg-primary text-white p-2 rounded-lg">
                <FiFileText size={24} />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800">
                  Session Notes
                </h2>
                <p className="text-sm text-gray-600">
                  Complete notes for all {patient.assignedSessions} assigned
                  sessions
                </p>
              </div>
            </div>

            <div className="text-right">
              <p className="text-sm text-gray-600">Completed Sessions</p>
              <p className="text-3xl font-bold text-primary">
                {sessionNotes.filter((n) => n.status === "completed").length}/
                {patient.assignedSessions}
              </p>
            </div>
          </div>

          {sessionNotes.length > 0 ? (
            <div className="space-y-4">
              {sessionNotes.map((note) => (
                <div
                  key={note.id}
                  className="border-2 border-teal-100 rounded-lg overflow-hidden"
                >
                  <div
                    className="bg-gradient-to-r from-primary to-cyan-600 text-white p-4 flex items-center justify-between cursor-pointer"
                    onClick={() =>
                      setExpandedNote(expandedNote === note.id ? null : note.id)
                    }
                  >
                    <div className="flex items-center gap-3">
                      {note.status === "completed" ? (
                        <BiCheckCircle size={24} className="text-emerald-300" />
                      ) : (
                        <FaClock size={24} className="text-yellow-300" />
                      )}
                      <div>
                        <h3 className="font-bold text-lg">
                          Session {note.sessionNumber}
                        </h3>
                        <p className="text-sm text-teal-100">
                          Click to{" "}
                          {expandedNote === note.id ? "collapse" : "expand"}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${
                          note.status === "completed"
                            ? "bg-emerald-500 text-white"
                            : "bg-yellow-500 text-white"
                        }`}
                      >
                        {note.status === "completed" ? "Completed" : "Pending"}
                      </span>
                    </div>
                  </div>

                  {expandedNote === note.id && (
                    <div className="p-4 bg-teal-50/30">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Session Notes
                      </label>
                      <textarea
                        value={note.content}
                        onChange={(e) =>
                          updateSessionNote(note.id, e.target.value)
                        }
                        placeholder="Write your observations, progress, and treatment notes for this session..."
                        className="w-full min-h-[200px] p-4 border-2 border-teal-200 rounded-lg focus:outline-none focus:border-primary/90 focus:ring-2 focus:ring-teal-200 transition-all resize-y"
                      />

                      <div className="flex gap-3 justify-end mt-4">
                        <button
                          onClick={() => setExpandedNote(null)}
                          className="px-5 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-semibold"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => saveSessionNote(note.id)}
                          className="px-5 py-2 bg-primary text-white rounded-lg hover:bg-primary_hover transition-colors font-semibold shadow-lg"
                        >
                          Save Session {note.sessionNumber}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12 text-gray-400">
              <FiFileText size={64} className="mx-auto mb-4 opacity-30" />
              <p className="text-lg">Loading session notes...</p>
            </div>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default SpecialistPatientScreen;
